module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('span', {
    staticClass: "part-catalog-card-brackets-list",
    class: _vm.classes
  }, [_vm._v("(" + _vm._s(_vm.joined) + ")")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e32fd44","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/sidebar/components/BracketsList.vue
// module id = fd4c8d9e6f0a45a6210d
// module chunks = 5